import React from "react";

import { SuspenseWrapper } from "../containers";

const MassEmail = React.lazy(() => import("../pages/MassEmail"));
const SentMails = React.lazy(() => import("../pages/MassEmail/SentMails"));
const Analytics = React.lazy(() => import("../pages/MassEmail/Analytics"));
const DistributionLists = React.lazy(() =>
  import("../pages/MassEmail/DistributionLists/DistributionListsPage")
);
const Templates = React.lazy(() =>
  import("../pages/Sequence/Templates/TemplatesPage")
);
const Distribution = React.lazy(() =>
  import("../pages/MassEmail/Distribution/DistributionPage")
);
const EditTemplate = React.lazy(() =>
  import("../pages/Sequence/EditTemplate/EditTemplatePage")
);

const NotFound = React.lazy(() => import("../pages/NotFound"));

const massEmailRouter = [
  {
    path: "",
    element: (
      <SuspenseWrapper>
        <MassEmail />
      </SuspenseWrapper>
    ),
  },
  {
    path: "sent-mails",
    element: (
      <SuspenseWrapper>
        <SentMails />
      </SuspenseWrapper>
    ),
  },
  {
    path: "analytics",
    element: (
      <SuspenseWrapper>
        <Analytics />
      </SuspenseWrapper>
    ),
  },
  {
    path: "distribution",
    children: [
      {
        path: "",
        element: (
          <SuspenseWrapper>
            <DistributionLists />
          </SuspenseWrapper>
        ),
      },
      {
        path: "edit/:id",
        element: (
          <SuspenseWrapper>
            <Distribution />
          </SuspenseWrapper>
        ),
      },
    ],
    errorElement: (
      <SuspenseWrapper>
        <NotFound />
      </SuspenseWrapper>
    ),
  },

  {
    path: "templates",
    children: [
      {
        path: "",
        element: (
          <SuspenseWrapper>
            <Templates />
          </SuspenseWrapper>
        ),
      },
      {
        path: "edit/:id",
        element: (
          <SuspenseWrapper>
            <EditTemplate />
          </SuspenseWrapper>
        ),
      },
      {
        path: "new",
        element: (
          <SuspenseWrapper>
            <EditTemplate />
          </SuspenseWrapper>
        ),
      },
    ],
    errorElement: (
      <SuspenseWrapper>
        <NotFound />
      </SuspenseWrapper>
    ),
  },
];

export default massEmailRouter;
